import { Button } from "components/Feature/Custom/Button";
import { CleanRelativeLink } from "components/Shared/DomainSplit";

import { TemplateDownloadIcon } from "./TemplateDownloadIcon";
import React from "react";
import { hrefIsTrackedFileDownload } from "src/util/href-download-handling";
import { useTrackedHrefDownload } from "src/hooks/useTrackedHrefDownload";

// NavigationSectionFields
type TemplateNavigationProps = {
  fields: NavigationSectionFields;
  ScrollTo: { SectionId: string; ScrollToText: string }[];
  SectionId: string;
  locale: string;
};
function TemplateNavigation1(props: TemplateNavigationProps) {
  const cta = useTrackedHrefDownload(props.locale, "mocHome");

  const scrollTopFunction = (value: any) => {
    if (value) {
      const element = document.getElementById(value);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  const onDownloadFile = () => void cta.handleMediaFieldDownload(props?.fields?.DownloadBtnFile?.value);

  const handleNavLinkClick = (rawHref: string | undefined, target?: string) => {
    if (!rawHref) return;
    void cta.handleHref(rawHref, target);
  };

  return (
    <div
      className={`${props?.locale}  pt-8 pb-6`}
      style={{ background: props?.fields?.NavigationBackgroundColor?.fields?.Title?.value }}
    >
      <div className="responsive w-full grid grid-cols-12">
        <div
          className="flex flex-wrap gap-5 !align-baseline items-center col-span-12 md:col-span-10"
          style={{ alignItems: "baseline !important" }}
        >
          {props?.fields?.ShowLinksAtEnd?.value &&
            props?.ScrollTo?.length > 0 &&
            props?.ScrollTo?.map(
              (link: { SectionId: string; ScrollToText: string }, index: number) => {
                return (
                  <span
                    onClick={() => scrollTopFunction(link?.SectionId)}
                    style={{
                      color: props?.fields?.NavigationTextColor?.fields?.Title?.value,
                      fontFamily: props?.fields?.NavigationTextFont?.fields.Title?.value,
                    }}
                    className="cursor-pointer !border-none md:!text-[14px] !text-[10px]  "
                    key={index}
                  >
                    {link?.ScrollToText}
                  </span>
                );
              }
            )}
          {Array.isArray(props?.fields?.Links) &&
            props?.fields?.Links?.length > 0 &&
            props?.fields?.Links?.map((link: Link, index: number) => {
              const rawHref = link?.fields?.ButtonUrl?.value?.href;
              const navStyle = {
                color: props?.fields?.NavigationTextColor?.fields?.Title?.value,
                fontFamily: props?.fields?.NavigationTextFont?.fields?.Title?.value,
              };
              return (
                <span className="cursor-pointer " key={index}>
                  {rawHref && hrefIsTrackedFileDownload(rawHref) ? (
                    <button
                      type="button"
                      style={navStyle}
                      className="border-none md:!text-[14px] !text-[10px] !flex !align-baseline !px-0 !py-0 bg-transparent cursor-pointer"
                      onClick={() => void handleNavLinkClick(rawHref, link?.fields?.ButtonUrl?.value?.target)}
                    >
                      {link?.fields?.ButtonText?.value}
                    </button>
                  ) : (
                    <Button
                      style={navStyle}
                      classNames={`border-none md:!text-[14px] !text-[10px] !flex !align-baseline  !px-0 !py-0 `}
                      redirect={
                        link?.fields?.ButtonUrl?.value
                          ? CleanRelativeLink(link?.fields?.ButtonUrl?.value?.href)
                          : ""
                      }
                      target={link?.fields?.ButtonUrl?.value?.target}
                      text={link?.fields?.ButtonText?.value}
                      linktype={link?.fields?.ButtonUrl?.value?.linktype}
                    />
                  )}
                </span>
              );
            })}
          {!props?.fields?.ShowLinksAtEnd?.value &&
            props?.ScrollTo?.length > 0 &&
            props?.ScrollTo?.map(
              (link: { SectionId: string; ScrollToText: string }, index: number) => {
                return (
                  <span
                    onClick={() => scrollTopFunction(link?.SectionId)}
                    style={{
                      color: props?.fields?.NavigationTextColor?.fields?.Title?.value,
                      fontFamily: props?.fields?.NavigationTextFont?.fields.Title?.value,
                    }}
                    className="cursor-pointer !border-none md:!text-[14px] !text-[10px]  "
                    key={index}
                  >
                    {link?.ScrollToText}
                  </span>
                );
              }
            )}
          {props?.fields?.DownloadBtnText?.value && props?.fields?.DownloadBtnFile?.value?.src && (
            <span className="cursor-pointer ">
              <button
                style={{
                  fontFamily: props?.fields?.NavigationTextFont?.fields?.Title?.value,
                  color: props?.fields?.NavigationTextColor?.fields?.Title?.value,
                }}
                onClick={onDownloadFile}
                className="animate-top inline-flex items-center gap-2 border-none md:!text-[14px] !text-[10px] !align-baseline !px-0 !py-0"
              >
                {props?.fields.DownloadBtnText?.value}
                <TemplateDownloadIcon
                  color={props?.fields?.NavigationTextColor?.fields?.Title?.value}
                  size={18}
                />
              </button>
            </span>
          )}
        </div>
        <div className="col-span-12 md:col-span-2  w-full flex justify-end items-start">
          {(() => {
            const rawCustom = props?.fields?.CustomBtnUrl?.value?.href;
            const customStyle = {
              color: props?.fields?.CustomBtnTextColor?.fields?.Title?.value,
              fontFamily: props?.fields?.CustomBtnTextFont?.fields?.Title?.value,
              background: props?.fields?.CustomBtnBoxColor?.fields?.Title?.value,
            };
            if (rawCustom && hrefIsTrackedFileDownload(rawCustom)) {
              return (
                <button
                  type="button"
                  style={customStyle}
                  className="border-none md:!text-[14px] !text-[10px] !flex !align-baseline !px-4 !py-2 mt-2 md:mt-0 rounded cursor-pointer"
                  onClick={() =>
                    void handleNavLinkClick(rawCustom, props?.fields?.CustomBtnUrl?.value?.target)
                  }
                >
                  {props?.fields?.CustomBtnText?.value}
                </button>
              );
            }
            return (
              <Button
                style={customStyle}
                classNames={`border-none md:!text-[14px] !text-[10px] !flex !align-baseline  !px-4 !py-2 mt-2 md:mt-0`}
                redirect={
                  rawCustom ? CleanRelativeLink(rawCustom) : ""
                }
                target={props?.fields?.CustomBtnUrl?.value?.target}
                text={props?.fields?.CustomBtnText?.value}
                linktype={props?.fields?.CustomBtnUrl?.value?.linktype}
              />
            );
          })()}
        </div>
      </div>
    </div>
  );
}

export default TemplateNavigation1;

export type NavigationCom = {
  displayName: "Navigation" | string;
  fields: NavigationSectionFields;
};

export type NavigationSectionFields = {
  SectionTemplate: {
    displayName: string;
    fields: {
      Title: {
        value: string;
      };
    };
  };
  Links: LinksType1;
  NavigationBackgroundColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  NavigationTextColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  NavigationTextFont: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  DownloadBtnText: {
    value: any;
  };
  DownloadBtnFile:
    | {
        value: {
          src: string;
          name: string;
          displayName: string;
          title: string;
          extension: string;
          mimeType: string;
          size: string;
        };
      }
    | any;
  CustomBtnUrl: {
    value: {
      href: string;
      linktype: string;
      url: string;
      target: string;
    };
  };
  CustomBtnText: {
    value: string;
  };
  CustomBtnBoxColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  CustomBtnTextColor: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  CustomBtnTextFont: {
    fields: {
      Title: {
        value: string;
      };
    };
  };
  ShowLinksAtEnd: {
    value: boolean;
  };
};

type LinksType1 = Link[];

export type Link = {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    ButtonText: {
      value: string;
    };
    ButtonUrl: {
      value: {
        href: string;
        linktype: string;
        url: string;
        anchor: string;
        target: string;
      };
    };
  };
};
